/* US States or CA Provinces where nug images are censored. 
  Response is hard coded to allow for future integration into compliance API 
*/
export default function getIsNugImageHidden(currentState: string) {
  const censoredStates = ["OH", "AB"];
  return censoredStates.includes(currentState);
}
